export default {
  methods: {
    goNextStage(needScroll = true) {
      for (let i = 0; i < this.stages.length; i += 1) {
        if (this.stages[i].active) {
          if (!this.stages[i + 1]) {
            break;
          }
          this.stages[i + 1].active = true;
          this.stages[i].active = false;
          this.stages[i].finished = true;
          if (needScroll) {
            window.scrollTo({
              top: 0,
              behavior: 'smooth',
            });
          }
          break;
        }
      }
    },
    goPrevStage(needScroll = true) {
      for (let i = 0; i < this.stages.length; i += 1) {
        if (this.stages[i].active) {
          if (!this.stages[i - 1]) {
            break;
          }
          this.stages[i - 1].active = true;
          this.stages[i - 1].finished = false;
          this.stages[i].active = false;
          this.stages[i].finished = false;
          if (needScroll) {
            window.scrollTo({
              top: 0,
              behavior: 'smooth',
            });
          }
          break;
        }
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/stagesSwitchers.js